const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COOPERATIVA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'COOPERATIVA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'COOPERATIVA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

    

        default:
            return state;
    }
}
